<template>
    <div>
        <hc-tabs v-model="componentsStatus" class="custom-tab">
            <div class="components-content">
                <hc-input
                    v-model="searchComponentName"
                    style="width: 200px;"
                    size="small"
                    placeholder="请输入组件包名称"
                    @change="toSearch"
                >
                    <span slot="suffix">
                        <i
                            v-show="!!searchComponentName"
                            class="hc-search-icon hc-icon-error hc-input__clear"
                            @click="clearKeyword"
                        />
                        <i
                            class="hc-search-icon hc-icon-search hc-input__clear"
                            @click="toSearch"
                        />
                    </span>
                </hc-input>
                <div v-show="componentsStatus === 'quotes'" class="actions">
                    <hc-button type="primary" :disabled="!selectedComponents.length" plain @click="updateQuotesLocal">
                        改为最新版本
                    </hc-button>
                </div>
            </div>
            <hc-tab-pane :label="`已引用(${quotesComponentsData.length})`" name="quotes">
                <component-table
                    ref="quotesComponentsTable"
                    :workspace-engine="currentWorkspaceEngine"
                    :loading="loading.components"
                    :components-data="quotesComponentsData"
                    is-already-use
                    @cancel-quotes="cancelQuotesLocal"
                    @alter-current-component-version="alterCurrentComponentVersion"
                    @select-change="selectChange"
                />
            </hc-tab-pane>
            <hc-tab-pane :label="`可引用(${allComponentsData.length})`" name="can">
                <component-table
                    ref="allComponentsTable"
                    :workspace-engine="currentWorkspaceEngine"
                    :loading="loading.components"
                    :components-data="allComponentsData"
                    @quotes-item="quotesItem"
                    @alter-current-component-version="alterCurrentComponentVersion"
                    @select-change="selectChange"
                />
            </hc-tab-pane>
        </hc-tabs>
            
        <div class="slider-footer">
            <hc-button :loading="loading.save" type="primary" @click="saveComponentStatus">
                保存
            </hc-button>
        </div>
    </div>
</template>
<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'

import { WORKSPACE } from '@common/store/module-types'
import {
    GET_WORKSPACE_COMPONENTS_LIST,
    UPDATE_COMPONENT_QUOTES_VERSION,
    GET_WORKSPACE_QUOTES_COMPONENTS_LIST,
} from '@common/store/workspace/types'
import { bus } from '@utils/event'

import componentTable from './components/componnet-table'

export default {
    name: 'AlterComponents',
    components: {
        componentTable,
    },
    props: {
        visible: {
            type: Boolean,
            default: () => false,
        },
    },
    data() {
        return {
            loading: {
                components: false,
                save: false,
            },
            searchComponentName: '',
            componentsStatus: '',
            quotesComponentsData: [],
            baseQuotesComponentsData: [],
            baseAllComponentsData: [],
            allComponentsData: [],
            selectedComponents: [],
            updateQuotesData: [],
            useQuotesData: [],
            savedData: [],
        }
    },
    computed: {
        ...mapGetters(WORKSPACE, {
            workspaceList: 'workspaceList',
        }),
        appInfo() {
            return this.$store.state.modeling.app
        },
        workspaceData() {
            return this.workspaceList.find(w => w.isMain === 1) || {}
        },
        currentWorkspaceEngine() {
            return this.appInfo.engineVersion
        },
        isTenantApp() {
            return this.$store?.state?.modeling?.app?.isTenant
        },
    },
    watch: {
        slideModalVisible: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.componentsStatus = 'quotes'
                    this.getQuotesComponents()
                    this.getAllComponents()
                }
            },
        },
        componentsStatus: {
            handler(val) {
                if (!this.slideModalVisible) return
                this.selectedComponents = []
                if (val === 'quotes') {
                    this.$refs.quotesComponentsTable && this.$refs.quotesComponentsTable.clearSelection()
                } else {
                    this.$refs.allComponentsTable && this.$refs.allComponentsTable.clearSelection()
                }
            },
        },
        '$route'(to) {
            const { name, params } = to
            if (name === 'components' && params && params.workspaceId) {
                this.initComponents()
            }
        },
    },
    mounted() {
        this.componentsStatus = 'quotes'
        this.initComponents()
    },
    methods: {
        ...mapActions(WORKSPACE, {
            getWorkspaceComponentList: GET_WORKSPACE_COMPONENTS_LIST,
            updateComponentQuotesVersion: UPDATE_COMPONENT_QUOTES_VERSION,
            getWorkspaceQuotesComponentList: GET_WORKSPACE_QUOTES_COMPONENTS_LIST,
        }),
        // 表格勾选变化触发
        selectChange(params) {
            this.selectedComponents = params
        },
        // 点击更改更改引用的当前组件版本
        alterCurrentComponentVersion(item) {
            const { alteredData } = item
            if (!alteredData.id) return
            this.updateQuotesData = [{
                componentPackageId: alteredData.id,
                componentPackageName: alteredData.name,
                componentPackageVersion: alteredData.version,
            }]
            this.updateCurrentComponentVersion(item)
        },
        // 更改展示数据
        updateCurrentComponentVersion(params) {
            let alterName = ''
            const { alteredIndex, alteredData } = params

            if (this.componentsStatus === 'quotes') {
                alterName = 'quotesComponentsData'
            } else {
                alterName = 'allComponentsData'
            }
            this.$set(this[alterName][alteredIndex], 'used', alteredData)
        },
        // 数据格式化
        initData() {
            this.quotesComponentsData = []
            this.baseQuotesComponentsData = []
            this.baseAllComponentsData = []
            this.allComponentsData = []
            this.selectedComponents = []
            this.updateQuotesData = []
            this.useQuotesData = []
            this.savedData = []
        },
        // 关闭侧滑弹窗回调
        closeSlider() {
            this.initComponents()
            this.$emit('closeSlider', 'alterComponents')
        },
        // 获取引用组件列表
        async getQuotesComponents() {
            const { $to } = this
            this.loading.components = true
            const [err, data] = await $to(this.getWorkspaceQuotesComponentList())
            
            if (!err) {
                this.quotesComponentsData = data.items
                this.baseQuotesComponentsData = _.clone(this.quotesComponentsData)
                this.savedData = [...this.quotesComponentsData]
            }
            this.loading.components = false
        },
        // 获取可用组件列表
        async getAllComponents() {
            const { $to } = this
            this.loading.components = true
            const [err, data] = await $to(this.getWorkspaceComponentList())

            if (!err) {
                this.allComponentsData = data.items
                this.baseAllComponentsData = _.clone(this.allComponentsData)
            }
            this.loading.components = false
        },
        // 点击保存
        async saveComponentStatus() {
            if (!this.validateComponentDeepVersion(this.savedData, this.savedData)) {
                // this.componentsStatus = 'quotes'
                return
            }
            let data = this.savedData.map(item => ({
                componentPackageName: item.name,
                componentPackageId: item.id,
                componentPackageVersion: (item.used && item.used.version) || item.version,
                isTenant: !!item.isTenant,
            }))
            if (this.isTenantApp) {
                data = data.filter(item => item.isTenant)
            }
            const { $to } = this
            const params = {
                componentPackage: data,
            }
            this.loading.save = true
            const [err] = await $to(this.updateComponentQuotesVersion(params))
            this.loading.save = false

            if (!err) {
                this.$message({
                    type: 'success',
                    message: '保存成功',
                })
                bus.$emit('change_work_space')
            }
        },
        // 校验组件的依赖组件的每个版本是否勾选、并满足版本一致
        checkComponentVersion(components, usedComponents) {
            // 未勾选的依赖
            const unChecked = []
            // 勾选的依赖版本不一致
            const versionConflict = []
            const canSelected = components.every(component => {
                const { used, versions, isSystem } = component
                const deps = (used && used.internalDependencies) || versions[0].internalDependencies
                // 非系统组件不能依赖系统组件
                const selectedComponents = usedComponents.filter(item => item.isSystem === isSystem)
                if (deps) {
                    return deps.every(dep => {
                        const currentComponent = selectedComponents.find(item => item.name === dep.name)
                        if (!currentComponent) {
                            const unCheckedItem = unChecked.find(item => item.componentName === component.name)
                            unCheckedItem ? unCheckedItem.depName.push(dep.name) : unChecked.push({
                                componentName: component.name,
                                depName: [dep.name],
                            })
                            return false
                        }
                        const currentComponentVersion = (currentComponent.used && currentComponent.used.version) || currentComponent.version
                        if (currentComponentVersion !== dep.version) {
                            const versionConflictItem = versionConflict.find(item => item.componentName === component.name)
                            if (versionConflictItem) {
                                versionConflictItem.dep.push({
                                    depName: dep.name,
                                    depVersion: dep.version,
                                })
                            } else {
                                versionConflict.push({
                                    componentName: component.name,
                                    needVersion: currentComponent.version,
                                    dep: [{
                                        depName: dep.name,
                                        depVersion: dep.version,
                                    }],
                                })
                            }
                        }
                        return currentComponentVersion === dep.version
                    })
                }
                return true
            })
            return {
                canSelected,
                unChecked,
                versionConflict,
            }
        },
        // 点击引用
        addToComponentLocal() {
            const usedComponents = [...this.selectedComponents, ...this.quotesComponentsData]
            if (!this.validateComponentDeepVersion(this.selectedComponents, usedComponents)) return

            this.useQuotesData = this.useQuotesData.concat(this.selectedComponents)
            this.allComponentsData = this.allComponentsData.filter(item => !~this.selectedComponents.findIndex(j => j.id === item.id))
            this.quotesComponentsData = this.quotesComponentsData.concat(this.selectedComponents)

            this.selectedComponents = []
        },
        // 校验当前组件依赖的组件是否引用，版本是否匹配
        validateComponentDeepVersion(selectedComponents, usedComponents) {
            const checkInfo = this.checkComponentVersion(_.cloneDeep(selectedComponents), _.cloneDeep(usedComponents))
            if (!checkInfo.canSelected) {
                const unCheckedTip = checkInfo.unChecked.reduce(
                    (pre, current) => `${pre}组件包${current.componentName}依赖组件包${current.depName.join('、')}请勾选;`, ''
                )
                const versionConflictTip = checkInfo.versionConflict.reduce((pre, current) => `${pre}组件包${current.componentName}依赖的组件包${current.dep.map(i => i.depName).join('、')}版本不一致`,
                    '')
                this.$message.error(`${unCheckedTip}${versionConflictTip}`)
                return false
            }
            return true
        },
        // 取消引用组件
        cancelQuotesLocal(row) {
            if (row.changeStatus) {
                this.savedData.push(row)
            } else {
                this.savedData = this.savedData.filter(i => i.id !== row.id)
            }
            this.$set(row, 'changeStatus', !row.changeStatus)
        },
        // 引用组件
        quotesItem(row) {
            if (row.changeStatus) {
                this.savedData = this.savedData.filter(i => i.id !== row.id)
            } else {
                this.savedData.push(row)
            }
            this.$set(row, 'changeStatus', !row.changeStatus)
        },
        // 更新引用组件版本
        updateQuotesLocal() {
            this.updateQuotesData = this.selectedComponents.reduce((base, item) => {
                const componentIndex = base.findIndex(component => component.id === item.id)
                const [maxVersionInfo] = item.versions
                const alteredIndex = this.quotesComponentsData.findIndex(quoat => quoat.id === item.id)
                    
                this.updateCurrentComponentVersion({
                    alteredIndex,
                    alteredData: maxVersionInfo,
                })
                const info = {
                    componentPackageId: item.id,
                    componentPackageName: item.name,
                    componentPackageVersion: item.latestVersion,
                }
                if (componentIndex < 0) {
                    return [
                        ...base,
                        info,
                    ]
                }
                base[componentIndex] = info
                return base
            }, this.updateQuotesData)
            this.selectedComponents = []
            this.$refs.quotesComponentsTable && this.$refs.quotesComponentsTable.clearSelection()
        },
        clearKeyword() {
            this.searchComponentName = ''
            this.toSearch()
        },
        // 查询组件
        toSearch() {
            const key = this.searchComponentName
            if (this.componentsStatus === 'quotes') {
                const components = _.cloneDeep(this.baseQuotesComponentsData)

                this.quotesComponentsData = components.filter(item => item.name.indexOf(key) >= 0)
            } else {
                const components = _.cloneDeep(this.baseAllComponentsData)

                this.allComponentsData = components.filter(item => item.name.indexOf(key) >= 0)
            }
        },
        initComponents() {
            this.quotesComponentsData = []
            this.allComponentsData = []
            this.getQuotesComponents()
            this.getAllComponents()
        },

    },
}
</script>
<style lang="less" scoped>
.custom-tab{
    
    /deep/ .hc-tabs__nav-wrap{
        padding: 0px;
    }
}
.components-name {
    font-weight: normal;
    color: #3E4352;
    font-size: 16px;
}
.components-content {
    display: flex;
    justify-content: space-between;
}
.slider-footer {
    padding-top: 12px;
}
</style>
